import axios from 'axios'
import request from './index'

export const getIndexEntityMap = (entityid) => {
  return request({
    url: '/screen/index/entity/map',
    method: 'post',
    data: {
	  command_id:84,
	  entityId:entityid
    }
  })
}

export const getIndexEntityCustomView = (entityid) => {
  return request({
    url: '/screen/index/entity/custom',
    method: 'post',
    data: {
	  command_id:84,
	  entityId:entityid
    }
  })
}

export const getIndexEntityWork = (entityid) => {
  return request({
    url: '/screen/index/entity/executework',
    method: 'post',
    data: {
	  command_id:84,
	  entityId:entityid
    }
  })
}

export const getIndexEntityEchart = (entityid,carid,seltime) => {
  return request({
    url: '/screen/index/entity/echarts',
    method: 'post',
    data: {
	  command_id:84,
	  entityId:entityid,
	  carId:carid,
	  selTime:seltime
    }
  })
}

export const getIndexEntityWarning = (entityId) => {
  return request({
    url: '/screen/index/entity/warning',
    method: 'post',
    data: {
	  command_id:84,
	  entityId:entityId
    }
  })
}

export const getReport = (command_id,entityId,carId,listQuery) => {
  return request({
    url: '/screen/index/report',
    method: 'post',
    data: {
	  command_id:command_id,
	  entityId:entityId,
	  carId:carId,
	  timeStart:listQuery.startTime,
	  timeEnd:listQuery.endTime,
	  datetype:listQuery.dateType
    }
  })
}

export const getWeather = (entityId) => {
  return request({
    url: '/weather/getWeather',
    method: 'post',
    data: {
	  entityId:entityId
    }
  })
}

export const handleWarning = (warnId) => {
  return request({
    url: '/screen/index/handleWarn',
    method: 'post',
    data: {
	  command_id:84,
	  warnid:warnId
    }
  })
}



// export const getIndexEntityIntroduce = (entityid) => {
//   return request({
//     url: '/screen/index/entity/left',
//     method: 'post',
//     data: {
// 	  command_id:84,
// 	  entityId:entityid
//     }
//   })
// }

// export const getIndexEntityCustom = (entityid) => {
//   return request({
//     url: '/screen/index/entity/right',
//     method: 'post',
//     data: {
// 	  command_id:84,
// 	  entityId:entityid
//     }
//   })
// }

// export const getIndexEntityEchart = (entityid) => {
//   return request({
//     url: '/screen/index/entity/alert',
//     method: 'post',
//     data: {
// 	  command_id:84,
// 	  entityId:entityid
//     }
//   })
// }
